"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isArray = void 0;

var isArray = Array.isArray || function (x) {
  return x && typeof x.length === 'number';
};

exports.isArray = isArray;